import React from 'react';
import { useNavigate } from 'react-router-dom';
import Info from '../../../assets/icon/Info.svg?react';
import LinkButton from '../../../components/common/Buttons/LinkButton';
import { DistanceMeasure } from '../../features/Map/DistanceMeasure/DistanceMeasure';
import HeaderLogo from './components/HeaderLogo';
import LoginButton from './components/LoginButton';
import MenuButton from './components/MenuButton';
import Notifications from './components/Notifications';
import SearchBar from './components/SearchBar/SearchBar';
import ShoppingCartButton from './components/ShoppingCartButton';
import useHeaderState from './hooks/useHeaderState';
import styles from './style/Header.module.scss';

interface HeaderProps {
  advertisingBannerClick: () => void;
}

interface NavigationItem {
  id: string;
  path?: string;
  href?: string;
  title: string;
  active?: boolean;
  target?: string;
  rel?: string;
}

const Header: React.FC<HeaderProps> = ({ advertisingBannerClick }) => {
  const {
    showPricingModal,
    showContactModal,
    showDownloadApiModal,
    showFeaturesModal,
    advertisingBannerButtonText,
    handleCart,
  } = useHeaderState();

  const navigate = useNavigate();

  const navigationItems: NavigationItem[] = [
    {
      id: 'Header-GetStarted_Button',
      path: '/features',
      title: 'GET STARTED',
      active: showFeaturesModal,
    },
    {
      id: 'Header-Pricing_Button',
      path: '/pricing',
      title: 'Pricing',
      active: showPricingModal,
    },
    {
      id: 'Header-Contact_Button',
      path: '/contact',
      title: 'Contact',
      active: showContactModal,
    },
    {
      id: 'Header-Api_Button',
      path: '/api',
      title: 'Api',
      active: showDownloadApiModal,
    },
  ];

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <HeaderLogo onClick={() => navigate('/')} />
        {navigationItems.map((item) => (
          <MenuButton
            key={item.id}
            id={item.id}
            data-testid={item.id}
            onClick={() => navigate(item?.path || '')}
            title={item.title}
            active={item.active}
            href={item.href}
            target={item.target}
          />
        ))}
      </div>

      <div className={styles.right}>
        <div className={styles.linkButtonContainer}>
          {localStorage.getItem('showAdvertisingBanner') === 'true' && (
            <LinkButton
              id="Header-AdvertisingBanner_Button"
              data-testid="Header-AdvertisingBanner_Button"
              onClick={advertisingBannerClick}
              title={advertisingBannerButtonText || 'Learn more'}
            >
              <Info className={styles.svg} />
            </LinkButton>
          )}
          <DistanceMeasure />
          <SearchBar />
        </div>

        <div className={styles.iconsContainer}>
          <LinkButton
            id="Header-Cart_Button"
            data-testid="Header-Cart_Button"
            smallHide={true}
            onClick={handleCart}
            aria-label="Shopping Cart"
          >
            <ShoppingCartButton />
          </LinkButton>

          <LinkButton
            id="Header-Notification_Button"
            data-testid="Header-Notification_Button"
            smallHide={true}
            onClick={() => navigate('/notifications')}
            aria-label="Notifications"
          >
            <Notifications />
          </LinkButton>
        </div>

        <LoginButton />
      </div>
    </header>
  );
};

export default Header;
